"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseSplMemoInstruction = void 0;
function parseSplMemoInstruction(ix) {
    return {
        title: "Save",
        type: "save",
        info: {
            data: ix.parsed,
        },
    };
}
exports.parseSplMemoInstruction = parseSplMemoInstruction;
//# sourceMappingURL=index.js.map